/* eslint-disable camelcase */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import { Form, minLengthValidator } from 'cvlib';

const PasswordForm = props => {
  const {
    password,
    login_password_option_button_next,
    login_password_option_button_cancel,
    password_tooltip_completeField_label_validation,
    ForgetPassword_passwordCV_HboMax_text,
    ForgetPassword_passwordCplay_HboMax_text,
    ForgetPassword_passwordCplay_HboMax_link,
  } = props.translations;
  const {
    onNextClicked,
    onClearError,
    onCancelClicked,
    isLoading,
    error,
    region,
    hogar,
    hboMaxIsEnabled,
  } = props;

  const [passwordValue, setPasswordValue] = useState('');
  const satisfyPassword = R.allPass([minLengthValidator(1)]);

  const onClickObtainPassword = () => {
    let url = `https://www.clarovideo.com/${region}/login?reset_password`;
    if (hogar) url = ForgetPassword_passwordCplay_HboMax_link;
    window.open(url, '_blank');
  };

  const label = hogar
    ? ForgetPassword_passwordCplay_HboMax_text
    : ForgetPassword_passwordCV_HboMax_text;

  const content = `<a>${label}</a>`;

  const elements = [
    {
      element: 'subtitle',
      content: password,
      expand: 0.3,
    },
    {
      element: 'item',
      type: 'password',
      name: 'password',
      id: 'password',
      expand: 3,
      autoFocus: true,
      defaultVisible: false,
      error: error.show && error.msg,
      rules: [],
      registerOptions: {
        required: password_tooltip_completeField_label_validation,
      },
      onChange: ({ target }) => {
        setPasswordValue(target.value);
        onClearError();
      },
    },
    {
      element: 'button',
      type: 'red',
      content: login_password_option_button_next,
      submit: onNextClicked,
      expand: 3,
      disabled: isLoading,
      dimmed: !satisfyPassword(passwordValue),
    },
    {
      element: 'button',
      type: 'gray',
      content: login_password_option_button_cancel,
      onClick: onCancelClicked,
      expand: 2,
      position: 'top',
      disabled: isLoading,
    },
    hboMaxIsEnabled && {
      element: 'message',
      className: 'hbo-container__span',
      content,
      position: 'bottom',
      expand: 1,
      onClick: onClickObtainPassword,
      clearErrorsOnClick: true,
    },
  ];

  const classes = ['hbo-container', 'content'];

  return <Form elements={elements} classes={classes} />;
};

PasswordForm.propTypes = {
  onNextClicked: PropTypes.func,
  onClearError: PropTypes.func,
  onCancelClicked: PropTypes.func,
  isLoading: PropTypes.bool,
  hboMaxIsEnabled: PropTypes.bool,
  region: PropTypes.string,
  hogar: PropTypes.bool,
  error: PropTypes.shape({
    show: PropTypes.bool,
    msg: PropTypes.string,
  }),
  translations: PropTypes.shape({
    password: PropTypes.string,
    login_password_option_button_next: PropTypes.string,
    login_password_option_button_cancel: PropTypes.string,
    password_tooltip_completeField_label_validation: PropTypes.string,
    ForgetPassword_passwordCV_HboMax_text: PropTypes.string,
    ForgetPassword_passwordCplay_HboMax_text: PropTypes.string,
    ForgetPassword_passwordCplay_HboMax_link: PropTypes.string,
  }),
};

export default PasswordForm;
